export default {"src":"/_next/static/media/search-icon.ac25527f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};